import React from 'react';
import {
    FooterContainer,
    FooterContent,
    FooterLinks,
    FooterLink,
    Copyright
} from './FooterElements';

const Footer = () => {
    return (
        <FooterContainer>
            <FooterContent>
                <FooterLinks>
                    <FooterLink 
                        href="https://docs.google.com/document/d/1Ejdc7fxC8ONUKLQgGZ0xuQYmU4ZTNAOLQCX5BCjoANc/edit?usp=sharing" 
                        target="_blank" 
                        rel="noopener noreferrer"
                    >
                        Privacy Policy
                    </FooterLink>
                </FooterLinks>
                <Copyright>
                    © {new Date().getFullYear()} Minute Growth. All rights reserved.
                </Copyright>
            </FooterContent>
        </FooterContainer>
    );
};

export default Footer; 